import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../data/mock";

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-[#F5F5F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-16 px-2 sm:px-0">
            <div className="divider-accent mx-auto"></div>
            <h2 className="heading-1 text-[#1C1917] mb-4 sm:mb-6 mt-6">
              Frequently Asked Questions
            </h2>
            <p className="body-large text-[#57534E] mb-2 sm:mb-3 text-sm sm:text-base">
              We understand and listen to our patients needs. For enquiries,
              please call us at{" "}
              <a
                href="tel:+96824698066"
                className="text-[#0F766E] hover:text-[#B45309] font-medium transition-colors duration-300 whitespace-nowrap"
              >
                +968 24 698066
              </a>
            </p>
            <p className="body-regular text-[#78716C] text-xs sm:text-sm">
              Sunday – Thursday: 9:00am – 6:30pm
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion
            type="single"
            collapsible
            className="space-y-3 sm:space-y-5 px-2 sm:px-0"
          >
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="bg-[#FFFFFF] border border-[#E7E5E4] px-4 sm:px-8 rounded-md shadow-refined overflow-hidden"
              >
                <AccordionTrigger className="text-left hover:no-underline py-4 sm:py-7">
                  <span className="heading-3 text-[#1C1917] pr-4 sm:pr-6 text-sm sm:text-base">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-4 sm:pb-7 pt-2">
                  <p className="body-regular text-[#57534E] leading-relaxed text-xs sm:text-sm">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Bottom CTA */}
          <div className="text-center mt-12 sm:mt-16 p-6 sm:p-10 bg-[#FFFFFF] border border-[#E7E5E4] rounded-lg shadow-refined mx-2 sm:mx-0">
            <p className="heading-3 text-[#1C1917] mb-4 sm:mb-6 text-sm sm:text-base">
              Still have questions?
            </p>
            <div className="flex flex-col gap-3 sm:gap-5 justify-center items-center">
              <a
                href="tel:+96824698066"
                className="btn-primary w-full sm:w-auto text-xs sm:text-sm px-4 sm:px-8 py-3 sm:py-4"
              >
                Call Us Now
              </a>
              <button
                onClick={() => {
                  const element = document.getElementById("appointments");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="btn-secondary w-full sm:w-auto text-xs sm:text-sm"
              >
                Book an Appointment
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
